export const PartnerTierTypes = Object.freeze({
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum'
});
/* List of partner IDs signed up for New Reports early Rollout  */

export const NEW_REPORTS_EAP_ROLLOUT_PARTNER_IDS = [1221170];